/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package tables.domain.interactor

class NoChangesException : Exception(message = "No changes.")